/**
 * Properties for a racer trail
 */
export class RacerTrailProperties {
    /**
     * Construct racer trail properties
     * @param {Number} color The trail color
     */
    constructor(color) {
        this.color = color;
    }
}